import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiUser, FiMail, FiLock, FiHome } from 'react-icons/fi';

const Register = () => {
  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="glass-card p-5 w-100"
        style={{ maxWidth: '500px' }}
      >
        <div className="text-center mb-4">
          <h2 className="fw-bold neon-text mb-2">Join Franchise OS</h2>
          <p className="text-muted">Register your business unit today</p>
        </div>

        <form>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label text-muted small fw-bold">First Name</label>
              <input type="text" className="form-control" placeholder="John" />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-muted small fw-bold">Last Name</label>
              <input type="text" className="form-control" placeholder="Doe" />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label text-muted small fw-bold">Email Address</label>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 text-muted"><FiMail /></span>
              <input type="email" className="form-control border-start-0 ps-0" placeholder="john@example.com" />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label text-muted small fw-bold">Branch Name</label>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 text-muted"><FiHome /></span>
              <input type="text" className="form-control border-start-0 ps-0" placeholder="Central Mall Branch" />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label text-muted small fw-bold">Password</label>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 text-muted"><FiLock /></span>
              <input type="password" className="form-control border-start-0 ps-0" placeholder="••••••••" />
            </div>
          </div>

          <button type="submit" className="btn btn-primary w-100 py-3 fw-bold mt-3">Create Account</button>
        </form>

        <div className="mt-4 text-center">
          <p className="text-muted small">
            Already have an account? <Link to="/login" style={{ color: 'var(--primary-color)' }} className="text-decoration-none fw-bold">Sign In</Link>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Register;
